import { Pipe, PipeTransform } from '@angular/core';
import { Article } from '../../home/models/article';
import { TruncatePipe } from './truncate.pipe';
import { StripHtmlPipe } from './strip-html.pipe';

@Pipe({
  name: 'asArticle'
})
export class AsArticlePipe implements PipeTransform {

  transform(value: any): Article {
    if (!value || !value.contentType) {
      return value;
    }
    switch (value.contentType) {
      case 'news':
      case 'events':
      case 'announcements':

        const truncatePipe = new TruncatePipe();
        const stripHtmlPipe = new StripHtmlPipe();

        return {
          id: value.Id,
          image: value.ImagePath,
          title: value.Title,
          publishDate: value.PublishDate,
          Intro: truncatePipe.transform(stripHtmlPipe.transform(value.Text), 200),
          contentType: value.contentType,
          plainText: stripHtmlPipe.transform(value.Text),
          text: value.Text,
          url: '',
          eventDate: value.eventDate
        };
      default:
        return value;
        break;
    }
  }
}
